import styled from 'styled-components';

export default styled.div`
  position: relative;
  padding: 0 0.5rem;
  ${({ fullscreen }) => (fullscreen ? `
    margin: 0 auto;
  ` : null)}
`;

export const Button = styled.button`
  display: block;
`;

export const Header = styled.div`
  padding: 2rem 0 1rem;
  text-align: center;
  font-weight: 600;
`;

export const Table = styled.table`
  width: 100%;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  line-height: 0;
`;

export const LoadingPrices = styled.div`
  position: absolute;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.COLOR_TEXT_MUTED};
`;
